<template>
   <div class="row">
      <div class="col-lg-6 col-xl-4">
         <div class="card m-b-30" style="min-height: 650px;">
             <div class="card-header">
                  <div class="row align-items-center">
                     <div class="col-9">
                        <h5 class="card-title mb-0">Mis datos</h5>
                     </div>
                     <div class="col-3">
                     </div>
                  </div>
               </div>
               <div class="card-body text-center" v-if="is_logged">
                  <div class="user-slider">
                     <div class="user-slider-item">
                           <img :src="userIcon" alt="avatar" width="100" class="rounded-circle mt-3 mb-4">
                           <h5>{{currentUserName}}</h5>
                           <p>{{currentUserId}}</p>
                           <p>{{address}}</p> 
                           <textarea class="form-control form-control-mid" v-model="direccion_edit" name="direccion" id="direccion" 
                           rows="3" placeholder="Ingrese mensaje"></textarea>
                     </div>
                  </div>
               </div>
               <div class="card-footer text-center">
                  <div class="row">
                     <div class="col-6 border-right">
                        <p class="my-2">Tel:</p> 
                        <p class="my-2" style="display: none;">{{phone}}</p> 
                        <input type="text" class="form-control form-control-mid" v-model="tel_edit" />
                     </div>
                     <div class="col-6">
                           <p class="my-2">Cel:</p>
                           <p class="my-2" style="display: none;">{{mobilePhone}}</p> 
                           <input type="text" class="form-control form-control-mid" v-model="cel_edit" />   
                     </div>
                  </div>
                  <br/>
                  <div class="row">
                     <div class="col-12">                      
                        <button type="button" class="btn btn-info-rgba my-1 mr-2" @click.stop="updateData">Actualizar datos</button>                
                     </div>
                  </div>
                  <br/>
                  <FileUploader accept=".pdf" @selected="uploadFile"/>
               </div>
         </div>
      </div>
      <div class="col-lg-6 col-xl-4">
         <div class="card m-b-30" style="min-height: 650px;">
               <div class="card-header">
                  <div class="row align-items-center">
                     <div class="col-9">
                        <h5 class="card-title mb-0">Días de visita</h5>
                     </div>
                     <div class="col-3">
                     </div>
                  </div>
               </div>
               <div class="card-body appointment-widget">
                  <h3>{{visitDay}}</h3>
                  <p>{{visitFrequency}}</p>
                  <ul class="list-unstyled py-3">
                     <li><i class="mdi mdi-circle text-primary mr-2"></i> Última visita: {{lastVisitDay}}</li>
                     <li> <br> </li>
                     <li><i class="mdi mdi-circle text-success mr-2"></i> Cliente desde: {{registerDay}}</li>
                  </ul>
                  <div class="row align-items-end">
                     <div class="col-9">
                     </div>
                     <div class="col-3">
                        <p class="bg-icon"><i class="feather icon-calendar"></i></p>
                     </div>
                  </div>
               </div>
         </div>
      </div>
      <div class="col-lg-6 col-xl-4">
         <div class="card m-b-30" style="min-height: 650px;">
               <div class="card-header">
                  <div class="row align-items-center">
                     <div class="col-9">
                        <h5 class="card-title mb-0">Datos de sucursal</h5>
                     </div>
                  </div>
               </div>
               <div class="card-body appointment-widget">
                  <h3>{{ruta_sucursal_info.nombre_sucursal}}</h3> 
                  <p>{{ruta_sucursal_info.direccion}}</p>
                  <p>{{ruta_sucursal_info.colonia}}</p>
                  <p>{{ruta_sucursal_info.poblacion}}, {{ruta_sucursal_info.estado}}</p>
                  <p>CP: {{ruta_sucursal_info.cp}}</p>
                  <ul class="list-unstyled py-3">
                     <li><i class="mdi mdi-circle-edit-outline text-success mr-2"></i> Ruta: {{ruta_sucursal_info.nombre_ruta}}</li>
                  </ul> 
                  <div class="row align-items-end">
                     <div class="col-9">
                     </div>
                     <div class="col-3">
                        <p class="bg-icon"><i class="feather icon-map"></i></p>
                     </div>
                  </div>
               </div>
         </div>
      </div> 
   </div>
</template>

<script>
import FileUploader from "@components/clients/FileUploader.vue"
import { mapState } from 'vuex';
import dateHelper from "@mixins/dateHelper"
import {Ruta_Sucursal} from "../../classes/ruta_sucursal"
import axios from "axios";

export default {
   components: { FileUploader },
   data(){
    return {   
      userIcon: require('@assets/images/users/boy.svg'),
      ruta_sucursal_info: null,
      direccion_edit: "",
      tel_edit : "",
      cel_edit : "",
    }
   },
   mixins: [dateHelper],
   async mounted(){
      await this.getRutaSucursalInfo();
   },   
  computed: {
      ...mapState("auth", ["user", "is_logged", "is_csf"]),
      currentUserName(){
         return this.user.Nombre_negocio;
      },
      currentUserId(){
         return this.user.Cliente;
      },
      address(){
         const add = this.user.Direccion;
         const col = this.user.Colonia
         const mun = this.user.Municipio
         const st = this.user.Estado
         const cp = this.user.CP

         this.direccion_edit = this.user.Direccion;
         
         let fadd = `${add}, ${col}, ${mun}, ${st}`;
         if(cp != null){
            fadd = `${fadd}, CP: ${cp}`;
         }
         return fadd;
      },
      phone(){
         const tel = this.user.Telefono
         this.tel_edit = this.user.Telefono;
         if(tel != null){
            return `Tel: ${tel}`;
         }
         else {
            return "Tel: ND";
         }
      },
      mobilePhone(){
         const tel = this.user.Celular
         this.cel_edit = this.user.Celular;
         if(tel != null){
            return `Cel: ${tel}`;
         }
         else {
            return "Cel: ND";
         }
      },
      visitDay(){
         return this.user.Dia_visita
      },
      visitFrequency(){
         const ff = this.user.Visita_dos_semanas
         if(ff == 1){
            return "Quincenalmente"
         }
         else {
            return "Semanalmente"
         }
      },
      lastVisitDay(){
         const last = this.user.Fecha_ultima_visita
         if(last != null){
            return this.dateTimeFormat(last)
         }
         else {
            return "--"
         }
      },
      registerDay(){
         const last = this.user.Fecha_creacion
         if(last != null){
            return this.regularDateFormat(last)
         }
         else {
            return "--"
         }
      },
      isloadCSF(){     
         return this.is_csf
      }
   },
   methods: {
      async getRutaSucursalInfo(){
         this.showLoader("Obteniendo información ...")
         const res = await this.xget('/rutaSucursalInfo/'+this.user.ID);
         if(res.success){
            this.setRutaSucursalInfo(res.data);
         }
         this.stopLoader()
      },
      setRutaSucursalInfo(rutaSucursalInfo){
         this.ruta_sucursal_info = Ruta_Sucursal.fromServiceRutaSucursal(rutaSucursalInfo)        
      },
      async updateData(){
         
         this.showLoader("Actualizando....")

         const cliente = {
            ID: this.user.ID,
            Direccion: this.direccion_edit,
            Tel : this.tel_edit,
            Cel : this.cel_edit
         } 

         const payload = {
            cliente: cliente
         }

         const res = await this.xpost("/update", payload);   
         this.stopLoader()   
         if (res.success) {
            this.successNotifDialog("Actualizado correctamente", "Los datos se han actualizado correctamente.")
         } else {
            this.errorNotifDialog("Ha ocurrido un error al actualizar los datos", res.data.message)
         }
      }, 
      async uploadFile(file) {

         file.ID_Producto = this.user.ID;
         file.type = file.type.split("/")[1];

         this.showLoader("subiendo información ...")
         const res = await axios.post(
            "https://api.sidi-e.com/api/cliente/csf",
            file
         );
         this.stopLoader()  
         //console.log(res)
         if (res.statusText == "OK") {
            this.successNotifDialog("Archivo subido correctamente", "El archivo se ha subido correctamente, en breve será revisado por el personal.")
         } else {
            this.errorNotifDialog("Ha ocurrido un error al subir el archivo", res.data.message)
         }
     },      
   }    
}
</script>